/**
 * The base view for this application. Initialises all objects and global events
 * @class
 */
Selector.View.AppView = Backbone.View.extend(
/** @lends UserDocs.View.AppView# */
{
	/** The events we're listening to*/
    events: {
    	"click #e_selector_reset": "resetQuestionaire",
        "click .e_selector_button_start" : "start",
    	"click .e_selector_init" : "initSelector",
        "click .landscape_tab_target > .icon": "goToGroup",
        "click .e_selector_tabs_left": "goToPrevGroup",
        "click .e_selector_tabs_right": "goToNextGroup",
	},

    /** template to use for Underscore.js rendering */
    template: _.template($('#selector_base').html()),
	
	questionList: null,

	/**
	 * Initialisation function called when this object is created. 
	 * Create all the 'global' objects to this app and trigger some rendering 
	 */
    initialize: function() {
    	this.initSelector();
    },

    initSelector: function(supressIntroduction){

        //allows app to be loaded on page without the DOM element being present
        this.setElement($("#e_document_selector"));

        this.$el.html(this.template());//add the base DOM
        this.$el.find("#e_selector_reset").hide();

        if (ele.selector.data) {
            /*--------------------*/
            /* object setup stuff */
            /*--------------------*/
            if (supressIntroduction || ele.selector.data.TEXT.INTRODUCTION === "") {
                this.start();
            } else {
                /* introduction */
                var introTemplate = _.template($('#selector_introduction').html());
                this.$el.find(".e_selector_introduction").html(introTemplate(ele.selector.data.TEXT));

            }
            /*------------------------*/
            /* end object setup stuff */
            /*------------------------*/
        }
    },

    destroySelector: function() {
        // COMPLETELY UNBIND THE VIEW
        this.undelegateEvents();

        this.$el.removeData().unbind();

        // Remove view from DOM
        this.remove();
        Backbone.View.prototype.remove.call(this);
    },

    goToGroup: function(e){
        let groupid = e.currentTarget.dataset.group;
        let model = this.questionList.findWhere({"IDNUM": parseInt(groupid)});

        this.questionList.activateQuestion(model);

        $('html, body').animate(
            {scrollTop: $("#e_document_selector").offset().top},
            500,
            'linear'
        );
    },

    goToPrevGroup: function(e){
        this.questionList.activatePrevQuestion();
    },

    goToNextGroup: function(e){
        this.questionList.activateNextQuestion();
    },

    start: function(){

        this.$el.find("#e_selector_reset").show();

        this.questionList = new Selector.Collection.QuestionList;
        this.questionList.key = ele.selector.data.CONFIG.SELECTORTYPE + "_selector";
        this.questionList.set(this.questionList.parse(ele.selector.data.QUESTIONS));

        let questionListView = new Selector.View.QuestionListView({collection: this.questionList});

        var questionTabListView = new Selector.View.QuestionTabListView({collection: this.questionList});
        this.$el.find(".e_selector_introduction").hide();

        //set up the result
        this.questionList.resultModel = new Selector.Model.Result({results: null});
        var resultView = new Selector.View.ResultView({model: this.questionList.resultModel});

        //set up the landscape
       //     var landscapeView = new Selector.View.LandscapeView({collection: this.questionList});


        this.questionList.resetAnswers();
        this.questionList.loadState();
        questionTabListView.render();
        if ($('.e_selector_button_result').length > 0) { $('.e_selector_button_result').click(); }
    },

    resetQuestionaire: function(){

        this.questionList.resetAnswers();
        this.questionList.resetState();
    	
    	this.$el.css("min-height", 0)
        $(".e_selector_warnings").html("");
        var $fixedNav = $('nav.fixed-top');
        var offset = 0;
        if ($fixedNav.length) {
            offset = $fixedNav.outerHeight();
        }
    	
		$('html,body').animate({
			scrollTop: $(".e_selector").offset().top- offset
	    }, 300);
    	
    	setTimeout(function(){
    	    if (ele.uri.getParameterByName(window.location.href, "sendEvents")) {
                var event = new CustomEvent('resizeIframe');
                window.parent.document.dispatchEvent(event);
                var event = new CustomEvent('scrollToIframe');
                window.parent.document.dispatchEvent(event);
            }
        }, 500);
    }

});